import React from "react";

// Why the form is locked, in the section's own words.
//
// This used to take an `isValidated` boolean alongside `isReadOnly`. The two were sourced
// independently — isReadOnly from the fetched status, isValidated from a localStorage snapshot —
// so whenever they disagreed (status "Locked", or a cache wiped on entry from a notification)
// the banner fell through to the generic view-mode wording and told the user they were in view
// mode while they were in edit mode looking at a validated section.
//
// Now it takes the status itself and names the actual reason. An unknown or missing status means
// there is no status-based lock, so view mode is the only thing left that can explain isReadOnly.
const STATUS_MESSAGES = {
  validated: "This section has been validated and can no longer be edited.",
  locked: "This section has been sent for MLNO approval and cannot be edited until it is returned.",
  "n/a": "This section is not applicable for this diligence level.",
  "not applicable": "This section is not applicable for this diligence level.",
};

const VIEW_MODE_MESSAGE = "You are in view mode. This form cannot be edited.";

export const readOnlyMessage = (status) =>
  STATUS_MESSAGES[String(status ?? "").trim().toLowerCase()] || VIEW_MODE_MESSAGE;

const ViewModeBanner = ({ isReadOnly, status }) => {
  if (!isReadOnly) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 20px",
        margin: "0 20px",
        backgroundColor: "#ffe08a",
        border: "1px solid #e6a800",
        borderRadius: "8px",
        fontSize: "14px",
        color: "#4d3800",
        fontWeight: "500",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      {readOnlyMessage(status)}
    </div>
  );
};

export default ViewModeBanner;
